// The VOIDED contract status, spelled once for the client.
//
// A void is a TERMINAL state that names no outcome: the question can never
// resolve, so there is no verdict to show. That makes it easy to mistake for
// "unresolved", which is the opposite claim — unresolved means the resolver
// looked and could not yet say, and the question may still settle.
//
// This status is AUTHORITATIVE over any verdict a row carries: read it first rather than
// assuming the two agree. Defense in depth — the failure is asymmetric, so the ordering
// holds however the pair arises, or whether it arises at all.
export const VOIDED_CONTRACT_STATUS = "voided";

// Is this forecast's contract voided? (`f.contractStatus`, server-sourced)
export function isVoidedContract(f) {
  return f?.contractStatus === VOIDED_CONTRACT_STATUS;
}
